import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt,FaUserShield,FaLock, FaMinus, FaPlus, FaChartLine, FaBalanceScale, FaNetworkWired, FaMobileAlt,  FaSync, FaDatabase, FaCode,FaLaptopMedical, FaServer,} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const FhirHealth = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">FHIR-Based Healthcare Connectivity</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs,We help healthcare organizations seamlessly integrate FHIR (Fast Healthcare Interoperability Resources) standards into their existing systems, enabling secure, scalable, and standardized healthcare data exchange.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full  mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "FHIR R4 & FHIR STU3",
        description: "Modern, structured data exchange solutions for seamless healthcare interoperability.",
        icon: FaServer
    },
    {
        title: "SMART on FHIR",
        description: "Secure app integrations with existing EHRs, enabling real-time healthcare data access.",
        icon: FaNetworkWired
    },
    {
        title: "Automated Workflows",
        description: "Streamlining patient care and clinical efficiency with intelligent automation.",
        icon: FaExchangeAlt
    },
    {
        title: "Enhanced Data Accessibility",
        description: "Ensuring interoperability across healthcare networks with standardized data exchange.",
        icon: FaLaptopMedical
    },
    {
        title: "Security & Compliance",
        description: "HIPAA, ONC, and global healthcare compliance with robust security measures.",
        icon: FaShieldAlt
    }
];


const services = [

    {
        title: "FHIR API Development & Integration",
        description: "Implement custom FHIR-compliant APIs for seamless data exchange between healthcare systems.",
        icon: FaCode
    },
    {
        title: "EHR & Telehealth Connectivity",
        description: "Ensure smooth interoperability between electronic health records, telemedicine platforms, and remote monitoring solutions.",
        icon: FaLaptopMedical
    },
    {
        title: "Data Standardization & Migration",
        description: "Convert and migrate legacy healthcare data into FHIR-compliant formats for better system compatibility.",
        icon: FaDatabase
    },
    {
        title: "SMART on FHIR Implementation",
        description: "Enable secure, app-based data sharing and interoperability using SMART on FHIR technology.",
        icon: FaSync
    },
    {
        title: "Healthcare App Development",
        description: "Build FHIR-powered healthcare applications for providers, patients, and healthcare stakeholders.",
        icon: FaMobileAlt
    },
    {
        title: "Security & Compliance Solutions",
        description: "Ensure HIPAA, HL7, and FHIR compliance with robust data encryption, authentication, and access control mechanisms.",
        icon: FaLock
    }
];
const whyChooseUs = [
    {
        title: "FHIR Expertise",
        description: "Our team specializes in FHIR R4, FHIR STU3, and SMART on FHIR, ensuring seamless system integration.",
        icon: FaUserShield
    },
    {
        title: "Scalable & Future-Ready",
        description: "Our solutions are designed for scalability, supporting growing data needs and evolving healthcare requirements.",
        icon: FaChartLine
    },
    {
        title: "Enhanced Data Security",
        description: "We prioritize end-to-end encryption, role-based access control, and audit logs for secure data exchange.",
        icon: FaLock
    },
    {
        title: "Seamless Interoperability",
        description: "Our integrations bridge the gap between disparate healthcare systems, improving data accessibility and workflow automation.",
        icon: FaExchangeAlt
    },
    {
        title: "Regulatory Compliance",
        description: "We ensure adherence to industry regulations like HIPAA, HL7, and ONC standards, making data sharing safe and compliant.",
        icon: FaBalanceScale
    }
];

const List = [
    
        {
            "title": "FHIR API Development & Customization",
            "description": "Build and integrate FHIR-compliant APIs tailored to your organization's needs. Our development services include custom API design, implementation, and optimization for seamless interoperability between healthcare applications, EHRs, and third-party platforms. We ensure compliance with HL7 FHIR standards to facilitate secure and efficient data exchange.",
            "icon": "FaCode"
        },
        {
            "title": "EHR & Patient Portal Integration",
            "description": "Enable real-time FHIR-based communication between electronic health records (EHR) systems and patient portals. Our integration services improve patient engagement by ensuring secure, seamless data sharing between healthcare providers and patients. This allows access to medical histories, lab results, prescriptions, and appointments in real time.",
            "icon": "FaUserMd"
        },
        {
            "title": "SMART on FHIR Implementation",
            "description": "Develop secure, interoperable healthcare applications using the SMART on FHIR framework. Our solutions empower developers to create user-friendly apps that connect with EHRs while ensuring compliance with industry standards for authentication, authorization, and data exchange. This enhances clinical workflows and supports decision-making.",
            "icon": "FaLock"
        },
        {
            "title": "Cloud-Based FHIR Solutions",
            "description": "Deploy scalable, cloud-powered FHIR applications that provide secure, on-demand data exchange between healthcare systems. We help organizations leverage cloud infrastructure to enhance performance, reduce operational costs, and ensure high availability of critical health information, all while maintaining compliance with data privacy regulations.",
            "icon": "FaCloud"
        },
        {
            "title": "FHIR Compliance & Security Audits",
            "description": "Ensure your FHIR implementations meet industry regulations and security standards, including HIPAA, GDPR, and HL7 FHIR specifications. Our security audits identify vulnerabilities, assess data protection measures, and provide actionable insights to safeguard patient information and maintain regulatory compliance.",
            "icon": "FaShieldAlt"
        }
    ]
    



export default FhirHealth;
